import React from 'react';
import Stack from '@mui/material/Stack';

import KitmanIcon from '../Icons';
import colors from '../../common/colors';
import { MatchDayStatusResultValues } from '../../common/consts';

type Props = {
  homeStatus?: string;
  awayStatus?: string;
};
const MatchDayStatusInfo = (props: Props) => {
  const getIconName = (dmrStatus?: string) => {
    switch (dmrStatus) {
      case MatchDayStatusResultValues.complete:
        return 'CheckCircleOutline';
      case MatchDayStatusResultValues.partial:
        return 'ContrastOutlined';
      default:
        return 'RadioBtnUnchecked';
    }
  };
  const getIconColor = (dmrStatus?: string) => {
    if (dmrStatus === 'COMPLETE') return { color: colors.green_200 };
    return { color: colors.grey_200 };
  };

  return (
    <Stack direction="row" spacing={1}>
      <KitmanIcon
        name={getIconName(props?.homeStatus)}
        sx={getIconColor(props?.homeStatus)}
      />
      {props.awayStatus !== undefined && (
        <KitmanIcon
          name={getIconName(props?.awayStatus)}
          sx={getIconColor(props?.awayStatus)}
        />
      )}
    </Stack>
  );
};

export default MatchDayStatusInfo;
